import { render, staticRenderFns } from "./CardChartGauge.vue?vue&type=template&id=cb6f09fe&"
import script from "./CardChartGauge.vue?vue&type=script&lang=js&"
export * from "./CardChartGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports